import { useEffect } from 'react';

/**
 * Hook para detectar cuando el usuario está navegando con el teclado
 * Agrega clase 'keyboard-navigation' al body cuando se detecta uso de teclado
 * Permite mostrar indicadores de foco solo durante navegación por teclado
 */
export const useKeyboardNavigation = () => {
  useEffect(() => {
    let isKeyboardNavigation = false;

    const handleMouseDown = () => {
      isKeyboardNavigation = false;
      document.body.classList.remove('keyboard-navigation');
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      // Detectar teclas de navegación: Tab, flechas, Enter, Espacio
      if (
        e.key === 'Tab' ||
        e.key === 'ArrowUp' ||
        e.key === 'ArrowDown' ||
        e.key === 'ArrowLeft' ||
        e.key === 'ArrowRight' ||
        e.key === 'Enter' ||
        e.key === ' '
      ) {
        isKeyboardNavigation = true;
        document.body.classList.add('keyboard-navigation');
      }
    };

    // Agregar event listeners
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);
};
